// ── Insight: Reservation Pickup ─────────────────────────────────────────────
export const INSIGHT_RESERVATION_PICKUP_REQUEST = 'INSIGHT_RESERVATION_PICKUP_REQUEST';
export const INSIGHT_RESERVATION_PICKUP_SUCCESS = 'INSIGHT_RESERVATION_PICKUP_SUCCESS';

// ── Insight: Booking Pace ────────────────────────────────────────────────────
export const INSIGHT_BOOKING_PACE_REQUEST = 'INSIGHT_BOOKING_PACE_REQUEST';
export const INSIGHT_BOOKING_PACE_SUCCESS = 'INSIGHT_BOOKING_PACE_SUCCESS';

// ── Insight: Productivity ────────────────────────────────────────────────────
export const INSIGHT_PRODUCTIVITY_REQUEST = 'INSIGHT_PRODUCTIVITY_REQUEST';
export const INSIGHT_PRODUCTIVITY_SUCCESS = 'INSIGHT_PRODUCTIVITY_SUCCESS';

// ── Shared ───────────────────────────────────────────────────────────────────
export const INSIGHT_PROCESS_SUCCESS = 'INSIGHT_PROCESS_SUCCESS';
export const INSIGHT_PROCESS_RESET   = 'INSIGHT_PROCESS_RESET';

export interface InsightReservationPickupRequest {
  type: typeof INSIGHT_RESERVATION_PICKUP_REQUEST;
  payload: {
    period_type?: string | null;
    start_date?: string | null;
    end_date?: string | null;
    date_type?: string;
    segment?: string;
    segment_group?: string | null;
    sort_column?: string | null;
    limit_rows?: number | null;
    filter_text?: string | null;
    revenue_calc_type?: number | null;
  };
}

export interface InsightBookingPaceRequest {
  type: typeof INSIGHT_BOOKING_PACE_REQUEST;
  payload: {
    a_period_type?: string | null;
    a_start_date?: string | null;
    a_end_date?: string | null;
    b_period_type?: string | null;
    b_start_date?: string | null;
    b_end_date?: string | null;
    segment?: string;
    segment_group?: string | null;
    sort_column?: string | null;
    limit_rows?: number | null;
    filter_text?: string | null;
    revenue_calc_type?: number | null;
  };
}

export interface InsightProductivityRequest {
  type: typeof INSIGHT_PRODUCTIVITY_REQUEST;
  payload: {
    a_period_type?: string | null;
    a_start_date?: string | null;
    a_end_date?: string | null;
    b_period_type?: string | null;
    b_start_date?: string | null;
    b_end_date?: string | null;
    segment?: string;
    segment_group?: string | null;
    sort_column?: string | null;
    limit_rows?: number | null;
    filter_text?: string | null;
    revenue_calc_type?: number | null;
  };
}

export interface InsightProcessSuccess {
  type: typeof INSIGHT_PROCESS_SUCCESS;
  payload: { status: boolean; action: string; message: string };
}

export interface InsightProcessReset {
  type: typeof INSIGHT_PROCESS_RESET;
}

export type InsightAction =
  | InsightReservationPickupRequest
  | { type: typeof INSIGHT_RESERVATION_PICKUP_SUCCESS; payload: any[] }
  | InsightBookingPaceRequest
  | { type: typeof INSIGHT_BOOKING_PACE_SUCCESS; payload: any }
  | InsightProductivityRequest
  | { type: typeof INSIGHT_PRODUCTIVITY_SUCCESS; payload: any[] }
  | InsightProcessSuccess
  | InsightProcessReset;
